module.exports = __webpack_public_path__ + "img/handling-massive-product-db-in-magento.c9d7491b.webp";